import React from "react";
import CSSModules from "lib/utils/css-modules";
import { bindActionCreators } from "redux";
import { Button, Form, FormControl, Grid, AppSettings } from "lib/index";
import StWidget, { widgetComponentCode } from "./StWidget";
import WidgetRouteFormSection, { buildRouteParams } from "./WidgetRouteFormSection";
import styles from "./WidgetsSettingsView.less";
import { connect } from "react-redux";
import { createWidget, updateWidget, initializeView } from "./index";
import store from "app/store";
import { createAlert } from "modules/app/actions";

@connect(
  (state) => ({
    currentCompany: state.auth.company.model,
    widgets: state.settings.WidgetsSettingsView,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
      },
      dispatch
    )
)
@CSSModules(styles)
export default class ButtonWidgetView extends React.Component {
  constructor(...args) {
    super(...args);
    const { company, products, marketplace } = this.props;

    this.state = {
      active: false,
      isWidgetsLoaded: false,
      isSaveDisabled: false,
      hasChanged: false,
      showCode: true,
      widget: {
        options: {
          routeParams: buildRouteParams({ company, products, marketplace }),
          content: I18n.t("papp.settings.ButtonWidgetView.book_now"),
          openInModal: true,
          color: "teal",
          size: "normal",
          fixedPlacement: false,
          locale: null,
          currency: null,
          type: "button",
          active: false,
        },
        widget_type: "button",
      },
    };
  }

  componentDidMount() {
    this.initialiseWidget();
  }
  componentDidUpdate() {
    this.initialiseWidget();
  }
  initialiseWidget = () => {
    if (!this.state.isWidgetsLoaded) {
      const w = this.getWidget(this.props.widgets);
      if (w) {
        this.setState((prevstate) => ({
          ...prevstate,
          widget: w,
        }));
      }
    }
  };

  getWidget(state) {
    let widget = null;
    if (state.widgets && state.widgets.data) {
      this.setState((prevstate) => ({
        ...prevstate,
        isWidgetsLoaded: true,
      }));
      for (let w of state.widgets.data) {
        if (w.attributes.widget_type === "button") {
          widget = w.attributes;
          break;
        }
      }
    }
    return widget;
  }

  onButtonClick = () => {
    this.setState((prevstate) => ({
      ...prevstate,
      showCode: !this.state.showCode,
      hasChanged: false,
      isSaveDisabled: true,
    }));
    let widgetDTO = { ...this.state.widget };
    widgetDTO.options.href = widgetDTO.options.routeParams.url;
    if (this.state.widget.id) {
      updateWidget({ widget: widgetDTO }).subscribe(() => {
        store.dispatch(
          createAlert({
            type: "success",
            content: I18n.t("papp.common.submit_success_message"),
            timeout: 3000,
          })
        );
        this.unlockSave();
      });
    } else {
      createWidget({ widget: widgetDTO })
        .toPromise()
        .then((w) => {
          this.setState((prevstate) => ({
            ...prevstate,
            widget: w.data.data.attributes,
          }));
          this.props.initializeView();
          this.unlockSave();
        });
    }
  };

  unlockSave = () => {
    this.setState((prevstate) => ({
      ...prevstate,
      isSaveDisabled: false,
    }));
  };

  updateWidgetState = (name, val) => {
    let newState = Object.assign({}, this.state);
    newState.widget.options[name] = val;
    newState.hasChanged = true;
    if (name === "active") {
      newState.widget.active = val;
    }
    this.setState(newState);
  };

  render() {
    const { company, products, marketplace } = this.props;
    const { routeParams, content, openInModal, color, size, fixedPlacement, locale, currency, active } =
      this.state.widget.options;
    const { showCode, hasChanged, isSaveDisabled } = this.state;
    const colorOptions = [
      ["blue", I18n.t("papp.settings.NavBarWidgetView.blue")],
      ["teal", I18n.t("papp.settings.NavBarWidgetView.teal")],
      ["orange", I18n.t("papp.settings.NavBarWidgetView.orange")],
    ];
    const sizeOptions = [
      ["small", I18n.t("papp.settings.ButtonWidgetView.small_size")],
      ["normal", I18n.t("papp.settings.ButtonWidgetView.normal_size")],
      ["large", I18n.t("papp.settings.ButtonWidgetView.large_size")],
    ];
    const fixedPlacementOptions = [
      ["bottomRight", I18n.t("papp.settings.ButtonWidgetView.bottom_right")],
      ["bottomLeft", I18n.t("papp.settings.ButtonWidgetView.bottom_left")],
      ["centerRight", I18n.t("papp.settings.ButtonWidgetView.center_right")],
      ["centerLeft", I18n.t("papp.settings.ButtonWidgetView.center_left")],
      ["topRight", I18n.t("papp.settings.ButtonWidgetView.top_right")],
      ["topLeft", I18n.t("papp.settings.ButtonWidgetView.top_left")],
    ];
    const openInModalOptions = [
      ["__stModal", I18n.t("papp.settings.ButtonWidgetView.in_modal")],
      ["_blank", I18n.t("papp.settings.ButtonWidgetView.in_new_tab")],
    ];

    const widgetProps = {
      component: "Button",
      href: routeParams.url,
      content,
      openInModal,
      color,
      size,
      fixedPlacement,
    };
    return (
      <div>
        {this.state.isWidgetsLoaded && (
          <div styleName="widget-container">
            <div styleName="widget-form">
              <Form>
                <h3>{I18n.t("papp.settings.ButtonWidgetView.title")}</h3>
                <Grid columns={2}>
                  <Grid.Column>
                    <FormControl.Checkbox
                      label={I18n.t("papp.settings.WidgetsSettingsView.active")}
                      checked={!!active}
                      onChange={(checked) => this.updateWidgetState("active", checked ? true : false)}
                      toggle
                    />
                    <WidgetRouteFormSection
                      company={company}
                      products={products}
                      marketplace={marketplace}
                      locale={locale}
                      currency={currency}
                      value={routeParams}
                      onChange={(routeParams) => this.updateWidgetState("routeParams", routeParams)}
                    />

                    <FormControl.LocaleSelectFormGroup
                      inlineLabel
                      label={I18n.t("papp.settings.WidgetsSettingsView.locale")}
                      value={locale}
                      onChange={(locale) => this.updateWidgetState("locale", locale)}
                      locales="customer_locales"
                      includeBlank
                      placeholder={I18n.t("papp.settings.WidgetsSettingsView.detect_from_visitor_browser")}
                    />

                    <FormControl.SelectFormGroup
                      inlineLabel
                      label={I18n.t("papp.settings.WidgetsSettingsView.currency")}
                      value={currency}
                      onChange={(currency) => this.updateWidgetState("currency", currency)}
                      options={AppSettings.frontend_currencies.filter(
                        (currency) => !["GBP", "TRY"].includes(currency)
                      )}
                      includeBlank
                      placeholder={I18n.t("papp.settings.WidgetsSettingsView.detect_from_visitor_browser")}
                    />

                    <FormControl.InputFormGroup
                      inlineLabel
                      label={I18n.t("papp.settings.ButtonWidgetView.button_content")}
                      value={content}
                      onChange={(content) => this.updateWidgetState("content", content)}
                    />

                    <FormControl.MultipleRadioFormGroup
                      inlineLabel
                      inline
                      label={I18n.t("papp.settings.ButtonWidgetView.open")}
                      value={openInModal ? "__stModal" : "_blank"}
                      onChange={(v) => this.updateWidgetState("openInModal", v === "__stModal" ? true : false)}
                      options={openInModalOptions}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <FormControl.MultipleRadioFormGroup
                      inlineLabel
                      inline
                      label={I18n.t("papp.settings.ButtonWidgetView.color")}
                      value={color}
                      onChange={(color) => this.updateWidgetState("color", color)}
                      options={colorOptions}
                    />

                    <FormControl.MultipleRadioFormGroup
                      inlineLabel
                      inline
                      label={I18n.t("papp.settings.ButtonWidgetView.size")}
                      value={size}
                      onChange={(size) => this.updateWidgetState("size", size)}
                      options={sizeOptions}
                    />

                    <FormControl.FormGroup inline>
                      <FormControl.Checkbox
                        label={I18n.t("papp.settings.ButtonWidgetView.stick_to_window_corner")}
                        checked={!!fixedPlacement}
                        onChange={(checked) => this.updateWidgetState("fixedPlacement", checked ? "bottomLeft" : false)}
                        toggle
                      />

                      <FormControl.Select
                        value={fixedPlacement || null}
                        onChange={(fixedPlacement) => this.updateWidgetState("fixedPlacement", fixedPlacement)}
                        options={fixedPlacementOptions}
                        className="u-mediumWidth"
                        style={{
                          visibility: !fixedPlacement ? "hidden" : undefined,
                        }}
                      />
                    </FormControl.FormGroup>
                  </Grid.Column>
                </Grid>

                <br />
                <Button
                  primary
                  disabled={!hasChanged || isSaveDisabled}
                  as="a"
                  onClick={this.onButtonClick}
                  content={I18n.t("papp.settings.ButtonWidgetView.generate_code")}
                />
              </Form>
            </div>

            {showCode && !fixedPlacement && (
              <div styleName="widget-code">
                <ol>
                  <li>
                    <p>{I18n.t("papp.settings.ButtonWidgetView.put_widget_anywhere")}</p>
                    <FormControl.TextArea
                      disabled="disabled"
                      style={{ width: "600px" }}
                      rows="5"
                      value={widgetComponentCode(widgetProps)}
                    />
                  </li>
                </ol>
              </div>
            )}

            <hr />

            <div styleName="widget-example">
              <h3>{I18n.t("papp.settings.ButtonWidgetView.preview")}</h3>
              <StWidget widgetProps={widgetProps} />
            </div>
          </div>
        )}
        <p />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/WidgetsSettingsView/ButtonWidgetView.jsx